import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-progress-item',
    templateUrl: './progress-item.component.html',
    styleUrls: ['./progress-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressItemComponent implements OnInit {

  @Input()
  public value: number = 0;

  @Input()
  public state: 'normal' | 'ok' | 'warn' | 'danger' = 'normal';


  constructor() { }

  ngOnInit(): void {
  }

}
